import React from "react";
//#region types
import { SelectInputProps } from "models/propTypes/wintFormPropsTypes";
import { RutRotStepProps } from "models/propTypes/customerImportPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { HorizontalFormField, SelectInput, WizardSection } from "components/common/wintForms";
//#endregion
import { CsvImportHelper, LocalizationHelperInstance } from "utils/helpers";

const RutRotStep: React.FC<RutRotStepProps> = ({ connect, headersObject, submitted, wizardProps }) => {
  return (
    <WizardSection header={TranslationKeys.Invoice.RutRot} submitted={submitted} wizardProps={wizardProps}>
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("propertyDesignationColumn")}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PropertyDesignation)}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PropertyDesignation)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        items={headersObject}
        optional
      />
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("tenantsOwnerAssociationOrgNumberColumn")}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.TenantsOrgNumber)}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.TenantsOrgNumber)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        items={headersObject}
        optional
      />
      <HorizontalFormField<SelectInputProps>
        Component={SelectInput}
        {...connect("apartmentNumberColumn")}
        controlLabel={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ApartmentNumber)}
        label={CsvImportHelper.getColumnSelectFieldLabel(
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ApartmentNumber)
        )}
        placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SelectColumn)}
        items={headersObject}
        optional
      />
    </WizardSection>
  );
};

export default RutRotStep;
